import { render, staticRenderFns } from "./UpgradeYourPlanModal.vue?vue&type=template&id=b73d6b6c&"
import script from "./UpgradeYourPlanModal.vue?vue&type=script&lang=ts&"
export * from "./UpgradeYourPlanModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports